import { atom } from "recoil";

export const hasMoreState = atom({
  key: "hasMoreState",
  default: false,
});
